import { render, staticRenderFns } from "./virtualOrdersProductReports.vue?vue&type=template&id=842ba7ca&"
import script from "./virtualOrdersProductReports.vue?vue&type=script&lang=js&"
export * from "./virtualOrdersProductReports.vue?vue&type=script&lang=js&"
import style0 from "./virtualOrdersProductReports.vue?vue&type=style&index=0&id=842ba7ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports